export const spacing = {
  0: '0',
  1: '4px',
  2: '8px',
  3: '12px',
  4: '16px',
  5: '20px',
  6: '24px',
  7: '28px',
  8: '32px',
  9: '40px',
  10: '48px',
  11: '56px',
  12: '64px',
  13: '80px',
  14: '96px',
  15: '120px',
  16: '160px',
} as const;

export const radii = {
  xs: '6px',
  sm: '10px',
  md: '14px',
  lg: '22px',
  xl: '32px',
  pill: '999px',
} as const;

export type Shadows = { sh1: string; sh2: string; sh3: string };

export const shadows: Shadows = {
  sh1: '0 1px 2px rgba(10,10,12,0.04), 0 0 0 1px rgba(10,10,12,0.05)',
  sh2: '0 8px 24px -6px rgba(10,10,12,0.08), 0 0 0 1px rgba(10,10,12,0.04)',
  sh3: '0 24px 60px -20px rgba(10,10,12,0.18), 0 0 0 1px rgba(10,10,12,0.04)',
};

export const shadowsDark: Shadows = {
  sh1: '0 1px 2px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,255,255,0.04)',
  sh2: '0 8px 24px -6px rgba(0,0,0,0.55), 0 0 0 1px rgba(255,255,255,0.04)',
  sh3: '0 24px 60px -20px rgba(0,0,0,0.7), 0 0 0 1px rgba(255,255,255,0.04)',
};

export const widths = {
  max: '1240px',
  narrow: '880px',
  reading: '680px',
} as const;

export const breakpoints = {
  sm: '480px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
} as const;

export const motion = {
  duration: { micro: '120ms', fast: '180ms', base: '240ms', slow: '400ms', panel: '600ms' },
  easing: {
    out: 'cubic-bezier(0.22, 0.61, 0.36, 1)',
    standard: 'cubic-bezier(0.4, 0, 0.2, 1)',
    in: 'cubic-bezier(0.4, 0, 1, 1)',
  },
} as const;

export type Spacing = typeof spacing;
export type Radii = typeof radii;
export type Widths = typeof widths;
export type Breakpoints = typeof breakpoints;
export type Motion = typeof motion;
